import script from "./TermChangeList.vue?vue&type=script&setup=true&lang=js"
export * from "./TermChangeList.vue?vue&type=script&setup=true&lang=js"

import "./TermChangeList.vue?vue&type=style&index=0&id=fd61339a&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Contractly\\Contractly.Site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd61339a"]])

export default __exports__